import { render } from "./IconLogout.vue?vue&type=template&id=dbfecf3c"
import script from "./IconLogout.vue?vue&type=script&lang=ts"
export * from "./IconLogout.vue?vue&type=script&lang=ts"
script.render = render

export default script